
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.664 5.945V4.852L7.024.39v1.171L1.71 5.399l5.312 3.836v1.172L.664 5.946zm5.563 0V4.852L12.586.39v1.171L7.273 5.399l5.313 3.836v1.172l-6.36-4.46z","fill":"currentColor"}})])
          )
        }
      }
    